// extracted by mini-css-extract-plugin
export default {"animated-loading-overlay":"styles_animated-loading-overlay__YIbfy","large":"styles_large__Dit1n","medium":"styles_medium__OnDVY"};